import { useLocation, useRouteMatch } from 'react-router-dom';
import useRouteQuery from '../useRouteQuery';

function useRouteParams() {
  return [useRouteMatch().params, useLocation().state, useRouteQuery()];
}

export default useRouteParams;